type ResolveSalesTaxLiabilityTaxableLineIdsArgs = {
  taxableLineIds?: string[] | null;
  localStorageKey: string;
  previousLocalStorageKey: string;
  readTaxableLineIds: (key: string) => string[] | null | undefined;
};

export const sanitizeSalesTaxLiabilityTaxableLineIds = (
  taxableLineIds?: string[] | null
) => taxableLineIds?.filter(Boolean) ?? [];

export const resolveSalesTaxLiabilityTaxableLineIds = ({
  taxableLineIds,
  localStorageKey,
  previousLocalStorageKey,
  readTaxableLineIds,
}: ResolveSalesTaxLiabilityTaxableLineIdsArgs) => {
  if (localStorageKey !== previousLocalStorageKey) {
    return sanitizeSalesTaxLiabilityTaxableLineIds(
      readTaxableLineIds(localStorageKey)
    );
  }

  return sanitizeSalesTaxLiabilityTaxableLineIds(taxableLineIds);
};
